import type { VERTEX_TYPE } from './constants';
export type VertexT = {
  point: [number, number];
  type: (typeof VERTEX_TYPE)[keyof typeof VERTEX_TYPE];
  color?: string;
};